<div class="container" *ngIf="isMobile$ | async">
  <tvb-plp-filters-mobile-menu
    *ngIf="showFilter"
    (clear)="onClearFilters(true)"
    (apply)="onApplyMobileSearch()"
    [totalItemsCount]="paginationConfig.totalItems"
  ></tvb-plp-filters-mobile-menu>

  <div class="row">
    <div class="col products-listing member-mobile">
      <div class="container-bio" *ngIf="member">
        <app-user-bio [member]="member"></app-user-bio>
      </div>

      <div class="listing-toolbar">
        <div class="listing-toolbar-row1">
          <button id="show-filters-btn" class="btn btn-secondary" (click)="toggleMobileMenu()">
            <i class="icon-filter"></i>
            {{ 'SHOW FILTERS' | translate }}
          </button>
        </div>

        <div class="listing-toolbar-row2">
          <ng-template [ngTemplateOutlet]="sortBySelect"></ng-template>
        </div>

        <div class="listing-toolbar-row3">
          <!-- Hide Wait List -->
          <!-- <div id="join-waitlist-btn" *ngIf="isAnyFilterSelected">
            <app-createalert></app-createalert>
          </div> -->
        </div>

        <ul class="filter-tags">
          <ng-container *ngFor="let item of searchService.searchRequest.value.filters">
            <ng-container *ngIf="isTagVisible(item.field)">
              <li>
                {{ prepareFilterValueForTag(item.field, item.value) | replace: '-':' ' | catalogDictionary }}
                <span class="remove-tag" (click)="removeTag(item)">✕</span>
              </li>
            </ng-container>
          </ng-container>
        </ul>

        <div class="listing-toolbar-row4" *ngIf="isAnyFilterSelected">
          <a id="clear-filters-btn" (click)="onClearFilters()" class="tvb-link">
            {{ 'Clear Filter' | translate }}
          </a>
        </div>

        <pagination-controls (pageChange)="onPageChange($event)" nextLabel="" previousLabel=""></pagination-controls>
      </div>

      <div class="products-cards">
        <ng-container *ngFor="let prod of products | paginate: paginationConfig; let i = index">
          <div class="card-box col-6 col-sm-4">
            <ng-container *ngIf="appConfig">
              <tvb-product-card-elk
                [product]="prod"
                [appConfig]="appConfig"
                [saleBadge]="saleBadgePercentageActive"
                [isImageLazyLoaded]="!(i <= numOfNotLazyProdImages)"
              ></tvb-product-card-elk>
            </ng-container>
          </div>
        </ng-container>
      </div>

      <div class="bottom-bar">
        <pagination-controls
          (pageChange)="onPageChange($event, false)"
          nextLabel=""
          previousLabel=""
        ></pagination-controls>
      </div>
    </div>
  </div>
</div>

<div class="container" *ngIf="!(isMobile$ | async)">
  <div class="row" *ngIf="!member">
    <div class="col-12 top-bar">
      <ng-template [ngTemplateOutlet]="sortBySelect"></ng-template>
      <pagination-controls (pageChange)="onPageChange($event)" nextLabel="" previousLabel=""></pagination-controls>
    </div>
  </div>

  <div class="row">
    <div class="col-12 col-lg-3 filters-sections" *ngIf="showFilter">
      <tvb-filters-section [initExpanded]="isMemberFiltersExpanded"></tvb-filters-section>
    </div>

    <div class="col-12 products-listing" [ngClass]="showFilter ? 'col-lg-9' : 'col-lg-12'">
      <div class="container-bio" *ngIf="member">
        <app-user-bio [member]="member"></app-user-bio>
      </div>

      <div class="member top-bar" *ngIf="member">
        <ng-template [ngTemplateOutlet]="sortBySelect"></ng-template>
        <pagination-controls (pageChange)="onPageChange($event)" nextLabel="" previousLabel=""></pagination-controls>
      </div>

      <div class="listing-toolbar" *ngIf="isAnyFilterSelected">
        <a (click)="onClearFilters()" class="clear-filters-btn tvb-link">
          {{ 'Clear Filter' | translate }}
        </a>

        <ul class="filter-tags">
          <ng-container *ngFor="let item of searchService.searchRequest.value.filters">
            <ng-container *ngIf="isTagVisible(item.field)">
              <li>
                {{ prepareFilterValueForTag(item.field, item.value) | replace: '-':' ' | catalogDictionary }}
                <span class="remove-tag" (click)="removeTag(item)">✕</span>
              </li>
            </ng-container>
          </ng-container>
        </ul>

        <!-- <div class="join-waitlist-btn">
          <app-createalert></app-createalert>
        </div> -->
      </div>

      <div class="products-cards">
        <ng-container *ngFor="let prod of products | paginate: paginationConfig; let i = index">
          <div class="card-box col-6 col-sm-4">
            <ng-container *ngIf="appConfig">
              <tvb-product-card-elk
                [product]="prod"
                [appConfig]="appConfig"
                [saleBadge]="saleBadgePercentageActive"
                [isImageLazyLoaded]="!(i <= numOfNotLazyProdImages)"
              ></tvb-product-card-elk>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 bottom-bar">
      <pagination-controls
        (pageChange)="onPageChange($event, false)"
        nextLabel=""
        previousLabel=""
      ></pagination-controls>
    </div>
  </div>
</div>

<ng-template #sortBySelect>
  <ng-select
    class="tvb-select sort-by-select"
    [items]="sortByOptions"
    [placeholder]=""
    [clearable]="false"
    [searchable]="false"
    [ngModel]="selectedSortBy"
    (change)="onChangeSortBy($event)"
  >
    <ng-option *ngFor="let item of sortByOptions" [value]="item.value">
      {{ item.label | translate }}
    </ng-option>
  </ng-select>
</ng-template>
